import { render, staticRenderFns } from "./recolumn-edit-wechat.vue?vue&type=template&id=7d7c2b78&scoped=true&"
import script from "./recolumn-edit-wechat.vue?vue&type=script&lang=js&"
export * from "./recolumn-edit-wechat.vue?vue&type=script&lang=js&"
import style0 from "./recolumn-edit-wechat.vue?vue&type=style&index=0&id=7d7c2b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7c2b78",
  null
  
)

export default component.exports